import yup, { enumValidator, integerPositiveValidator } from '~/utils/validators.yup';
import { GIVEN_TYPE_OPTIONS } from '~/config/constants';

export const typeDetailRule = {
    typeDetail: yup.object().shape({
        givenTypeOption: enumValidator(GIVEN_TYPE_OPTIONS),
        givenTypeValue: integerPositiveValidator.min(0).max(12),
        receivedTypeOption: enumValidator(GIVEN_TYPE_OPTIONS),
        receivedTypeValue: integerPositiveValidator.min(0).max(12),
        bidTypeOption: enumValidator(GIVEN_TYPE_OPTIONS),
    }),
};
